import { find } from "lodash";
import moment from "moment";
import { paymentT } from "../../../typings/payment";
import { LINK_PAYMENT_RELAUNCH_MIN, AFTER_SALE_PAYMENT_MAX } from "../../../thor.const";
import { Enums } from "../../../thor.enums";

export class LinkPaymentStatesController {
    public static $inject: string[] = [
        "$scope",
        "paymentService"
    ];

    // binded
    public containerEndDate: string;
    public isSlipPaid: boolean;
    public lastBidAmount: number;
    public payments: paymentT.Payment[];
    public saleCurrency: Enums.Currency;

    public linkPaymentStates: paymentT.thor.LinkPaymentState[];
    public linkPaymentStateTypeEnum = paymentT.thor.LinkPaymentStateType;
    public hasLinkPayment: { [index: string]: boolean }[] = [];
    public isLinkPaymentUpdateEnabled: { [index: string]: boolean }[] = [];
    public isLinkPaymentSuccess: { [index: string]: boolean }[] = [];
    public afterSalePaymentExpired: boolean;

    public isPaymentDone: boolean;

    constructor(
        $scope,
        protected paymentService
    ) {
        // disable link_payment actions (create, relaunch, reactivate) 40 days after sale
        this.afterSalePaymentExpired = this.checkOutdated(this.containerEndDate, { addDays: AFTER_SALE_PAYMENT_MAX });

        this.setLinkPayments();

        $scope.$watch(
            () => this.payments,
            () => this.setLinkPayments(),
            true
        );
    }

    protected setLinkPayments() {
        this.linkPaymentStates = this.payments
            ? this.paymentService.getLinkPaymentStates(this.payments, this.saleCurrency)
            : [];

        const linkPayment: { [index: string]: paymentT.thor.LinkPaymentState }[] = [];
        const item = this.linkPaymentStateTypeEnum.ITEM;
        const delivery = this.linkPaymentStateTypeEnum.DELIVERY;
        const addDays: number = LINK_PAYMENT_RELAUNCH_MIN;
        const hasExpired: string = "has_expired";

        [item, delivery].forEach((k: paymentT.thor.LinkPaymentStateType) => {
            linkPayment[k] = this.findLinkPayment(k);
            this.hasLinkPayment[k] = !!linkPayment[k];

            if (!this.hasLinkPayment[k]) {
                this.isLinkPaymentSuccess[k] = !!(k === item && this.isSlipPaid);
                return;
            }

            /* checks :
             * - if link payment success
             * - if link payment update is enabled (relaunch 7+ days/reactivate 15+ days after created or relaunched)
             * - if link payment is expired (40+ days after sale)
             */
            const upsertDate = linkPayment[k].last_relaunched_date || linkPayment[k].created;
            this.isLinkPaymentSuccess[k] =
                linkPayment[k].status === paymentT.LinkPaymentStatus.SUCCESS || !!(k === item && this.isSlipPaid);
            this.isLinkPaymentUpdateEnabled[k] = this.checkOutdated(upsertDate, { addDays });
            linkPayment[k][hasExpired] = this.checkOutdated(linkPayment[k].expiration_date);
        });

        this.isPaymentDone = this.isLinkPaymentSuccess[item] && this.isLinkPaymentSuccess[delivery];
    }

    protected findLinkPayment(type: paymentT.thor.LinkPaymentStateType): paymentT.thor.LinkPaymentState {
        return find(this.linkPaymentStates, (e: paymentT.thor.LinkPaymentState) => e.type === type);
    }

    private checkOutdated(date: string, { addDays }: any = {}) {
        const momentDate = moment(date);

        if (addDays) {
            momentDate.add(addDays, "days");
        }

        return momentDate.toDate() <= new Date();
    }
}
